import Contentful from 'contentful'

export enum ComponentDynamicKey {
  GGOTryIt = 'GGOTryIt',
  ToolSuite = 'ToolSuite',
  BtsAgents25 = 'BtsAgents25',
  BtsKeychain = 'BtsKeychain',
  GrammarlyAtWork25 = 'GrammarlyAtWork25',
  PersistentClientCtaSection = 'PersistentClientCtaSection',
  TrialCtaButton = 'TrialCtaButton',
}

export interface TypeComponentDynamicFields {
  internalName: Contentful.EntryFields.Symbol
  key: ComponentDynamicKey
}

export type TypeComponentDynamic = Contentful.Entry<TypeComponentDynamicFields>
